import * as React from "react";
import { GridItem } from "@chakra-ui/react";
import { useFormContext } from "react-hook-form";
import { TextInput } from "components";

const PasswordInputs: React.FC = () => {
  const { watch, setValue, resetField } = useFormContext();

  const confirmValue = watch("confirmPassword");

  return (
    <>
      <GridItem>
        <TextInput
          type="password"
          name="password"
          label="Password"
          placeholder="Password"
          autoComplete="new-password"
          onChange={event => {
            const newPass = event.target.value;
            setValue("password", newPass, {
              shouldDirty: true,
              shouldValidate: true,
              shouldTouch: true
            });
            if (!newPass && !confirmValue) {
              resetField("confirmPassword");
            }
          }}
        />
      </GridItem>
      <GridItem>
        <TextInput
          type="password"
          name="confirmPassword"
          label="Confirm Password"
          placeholder="Confirm Password"
        />
      </GridItem>
    </>
  );
};

export default PasswordInputs;
